import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface PageState {
  value: number | null;
}

const initialState: PageState = {
  value: null,
};

export const pageSlice = createSlice({
  name: "page",
  initialState,
  reducers: {
    setPage: (state, action: PayloadAction<number | null>) => {
      state.value = action.payload;
    },
  },
});

export const { setPage } = pageSlice.actions;
